import { track } from "../track";

interface Params {
  quiz_id?: string;
}

export const trackSignUpView = (params?: Params) =>
  track({ event: "sign_up_view", ...params });
